"use client";
import { Carousel, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Lang } from "@/i18n/settings";
import { AwardCategoriesSectionProps } from "@/services/home/types";
import DesktopCards from "./DesktopCards";
import { MobileCarousel } from "./MobileCarousel";
import { Shell } from "@/components/ui/shell";
import { Fade } from "@/components/ui/animations";
import Carpet from "@/components/ui/Carpet";

type Props = {
  data: AwardCategoriesSectionProps;
  lang: Lang;
};

export default function Categories({ data, lang }: Readonly<Props>) {
  return (
    <Carpet type="fade-light">
      <Carousel
        opts={{
          align: "start",
          direction: lang === "ar" ? "rtl" : "ltr",
          loop: true,
        }}
        className="w-full"
      >
        <Shell className="!pb-20 !pt-[78px] lg:flex xl:!overflow-x-visible">
          <div className="flex w-full flex-col gap-20">
            <Fade className="flex w-full items-center justify-between gap-4">
              <h1 className="text-[48px] leading-[64.32px] tracking-[-1.44px] text-[#F3E4CE] text-secondary ltr:font-playfair">
                {data.title}
              </h1>
              <div className="flex items-center gap-[10px] xl:hidden rtl:flex-row-reverse">
                <CarouselPrevious className="relative h-10 w-10 md:h-12 md:w-12" />
                <CarouselNext className="relative h-10 w-10 md:h-12 md:w-12" />
              </div>
            </Fade>
            <div className="xl:hidden">
              <MobileCarousel data={data.award_categories} />
            </div>
            <div className="hidden flex-col gap-20 xl:flex">
              <DesktopCards data={data.award_categories} />
            </div>
          </div>
        </Shell>
      </Carousel>
    </Carpet>
  );
}
